var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    rx: 42.5,
    fill: "#EEF0FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8958 28.3333H53.125V24.7917H49.5833V28.3333H35.4167V24.7917H31.875V28.3333H30.1042C28.1385 28.3333 26.5625 29.9271 26.5625 31.875V56.6667C26.5625 57.606 26.9356 58.5068 27.5998 59.171C28.264 59.8352 29.1649 60.2083 30.1042 60.2083H54.8958C55.8351 60.2083 56.736 59.8352 57.4002 59.171C58.0644 58.5068 58.4375 57.606 58.4375 56.6667V31.875C58.4375 30.9357 58.0644 30.0349 57.4002 29.3707C56.736 28.7065 55.8351 28.3333 54.8958 28.3333ZM54.8958 56.6667H30.1042V38.9583H54.8958V56.6667ZM54.8958 35.4167H30.1042V31.875H54.8958V35.4167Z",
    fill: "#0B29FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1add1f57841bf8a9bbed5500f5424bf3.svg";
export { ForwardRef as ReactComponent };